
import { Options, Prop, Watch } from "vue-property-decorator";
import DefaultLayout from "@/layout/DefaultLayout.vue";
import { mixins } from "vue-class-component";
import { minLength, required } from "@vuelidate/validators";
import Validation from "@/components/validation/Validation.vue";
// @ts-ignore
import uniqid from "uniqid";
import { TelephoneHelperMixin } from "@/mixins/TelephoneHelperMixin";
import { FormMixin } from "@/mixins/form/FormMixin";
import Spinner from "@/components/Spinner.vue";

@Options({
  components: {
    Spinner,
    DefaultLayout,
    Validation,
  },
  validations() {
    return {
      slug: { required, minLength: minLength(3) },
      titleDe: { required, minLength: minLength(3) },
      titleEn: { minLength: minLength(3) },
      contentDe: { required },
    };
  },
})
export default class PageForm extends mixins(FormMixin, TelephoneHelperMixin) {
  @Prop()
  public item?: any;

  @Prop()
  public isLoading: any;

  private slug?: string | null = null;
  private description?: string | null = null;
  private titleDe?: string | null = null;
  private titleEn?: string | null = null;
  private contentEn?: string | null = null;
  private contentDe?: string | null = null;

  private goToPage(): void {
    window.open(
      `${process.env.VUE_APP_BACKEND_BASE_URL}page/${this.item.slug}`
    );
  }

  private onSubmit(): void {
    if (this.isInvalidate()) {
      return;
    }
    const item: any = {
      slug: this.slug,
      titleDe: this.titleDe,
      titleEn: this.titleEn,
      description: this.description,
      contentEn: this.contentEn,
      contentDe: this.contentDe,
    };
    if (this.item?.id) {
      item.id = this.item.id;
    }
    this.$emit("on-submit", item);
  }

  @Watch("item", { immediate: true, deep: true })
  private onPageChange(item: any): void {
    if (item?.id) {
      this.slug = item.slug;
      this.description = item.description;
      this.titleDe = item?.titleDe;
      this.titleEn = item?.titleEn;
      this.contentEn = item.contentEn;
      this.contentDe = item.contentDe;
    }
  }
}
